import querystring from 'querystring'
import { createAction } from 'redux-actions'
import _ from 'lodash'
import log from 'blazar-sentry'

import { actionCreators as api } from 'reduxBits/api'

export const REQUEST_COMPLETIONS = 'Send an async autocomplete request to server'
export const RECEIVE_COMPLETIONS = 'Update the state with the fetched completions result'
export const CLEAR_COMPLETIONS = 'Remove the previous fetched completions.'
export const CHOOSE_SUGGESTION = 'Choose an autocomplete suggestion.'
export const CANCEL_SEARCH = 'Cancel search'

const requestCompletions = createAction(REQUEST_COMPLETIONS)
const receiveCompletions = createAction(RECEIVE_COMPLETIONS)
const clearCompletions = createAction(CLEAR_COMPLETIONS)
const chooseSuggestion = createAction(CHOOSE_SUGGESTION)
const cancelSearch = createAction(CANCEL_SEARCH)

const fetchCompletions = (userQuery) => async (dispatch) => {
  const query = _.pick(userQuery, ['q', 'cg'])
  if (!query.q) {
    log.info("Will not fetch completions due to invalid parameter 'q'.")
    // Since the user might have stale completions data in the store we need to remove those.
    dispatch(clearCompletions())
    return Promise.resolve()
  }

  dispatch(requestCompletions(query))

  const urlBit = 'autocomplete/v1'

  const url = `${urlBit}/autocomplete?${querystring.stringify(query)}`

  // /blocket endpoints need x-accept-charset header with is included with the legacyApiFetch
  // /autocomplete works with the regular fetch
  const response = await dispatch(api.fetch(url))

  if (response.ok) {
    return dispatch(receiveCompletions(response.textOrJson.completions, query))
  }

  return dispatch(receiveCompletions(response))
}

export const actionCreators = {
  fetchCompletions,
  cancelSearch,
  chooseSuggestion,
  clearCompletions,
}
